import { ref, computed } from "vue";
import { getTweakwiseId } from "@/core/api/graphql";
import { Logger } from "@/core/utilities";
import { globals } from "@/core/globals";
import { IS_DEVELOPMENT } from "@/core/constants";

export function useTweakwise() {
  const tweakwiseKey = ref<string | undefined>();
  const loading = ref(false);
  const { userId } = globals;

  async function fetchTweakwiseId(): Promise<void> {
    loading.value = true;

    try {
      const result = await getTweakwiseId();

      tweakwiseKey.value = result.environmentId;
    } catch (e) {
      Logger.error(`${fetchTweakwiseId.name}`, e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  async function loadTweakwise(key: string | undefined) {
    if (!key) {
      return;
    }

    const layerName = "tweakwiseLayer";

    (window as any)["_twa"] = layerName;
    (window as any)[layerName] = (window as any)[layerName] || [];

    const layer = (window as any)[layerName];

    layer.push({ "twa.start": new Date().getTime(), event: "twa.js" });
    layer.push({ "twa.instance": key, event: "twa.init" });

    // if (profileKey) {
    //   layer.push({ 'twa.profile': profileKey, event: 'twa.profile' });
    //   layer.getProfileKey = function () { return profileKey; };
    // }

    const f = document.getElementsByTagName("script")[0];
    const j = document.createElement("script");
    j.async = true;
    j.src = "//navigator-analytics.tweakwise.com/bundles/scout.js";
    f.parentNode?.insertBefore(j, f);
  }

  function tweakwiseEvent(event: string, args: any): void {
    if (IS_DEVELOPMENT) {
      Logger.debug("tweakwiseEvent, can't track event in development mode");
      return;
    }
    window.tweakwiseLayer.push({
      event: event,
      data: {
        ...args,
        profileKey: userId,
      },
    });
  }

  return {
    fetchTweakwiseId,
    tweakwiseKey: computed(() => tweakwiseKey.value),
    loadTweakwise,
    tweakwiseEvent,
  };
}
